(function () {
  class MultiplierTrail extends PIXI.Container {
    constructor() {
      super();

      this._segmentSize = 87;
      this._segmentsCount = 9;
      this._currentLevel = 1;
      this._currentFillerLevel = this._currentLevel;
      this._currentHeightShift = 0;
      this._minLevel = 1;
      this._maxLevel = 5;
      this._trail = undefined;
      this._defaultTrailData = {};
      this._shuffleIntroEventTask = undefined;
      this._previouslyGoldPanels = [];
      this._gameConfigSet = false;
      this._currentGoldText = undefined;
      this._textPulseShift = undefined;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleIntroEvent', this.onShuffleIntroEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.onShuffleEndEvent.bind(this));
      messageBus.subscribe('persistence:stakeChanged', this.onPersistenceStakeChanged.bind(this));
      messageBus.subscribe('scaleMultiplerTrail', this.scaleGoldText.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      messageBus.subscribe('sidewinder:xtraPowerRedBackground', this.onXtraPowerRedBackground.bind(this));

      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._panelParent = undefined;
      this._fillerBlue = undefined;
      this._fillerRed = undefined;
      this._fillerMask = undefined;

      this._panels = [];
    }

    update(delta, time) {}

    onGameConfigEvent() {
      this.onLayoutChange();

      this._fillerMask = resourceManager.get(this._jsonPath + ':bg:fillerMask');
      this._fillerMask.beginFill(0xffffff);
      this._fillerMask.drawRect(-40, 0, 80, this._segmentSize);
      this._fillerMask.endFill();
      this._fillerMask.pivot.y = this._fillerMask.height;
      this._fillerMask.position.set(0, 362);
      this._fillerMask.height = this._segmentSize;

      this._fillerBlue = resourceManager.get(this._jsonPath + ':bg:fillerBlue');
      this._fillerBlue.mask = this._fillerMask;

      this._fillerRed = resourceManager.get(this._jsonPath + ':bg:fillerRed');
      this._fillerRed.mask = this._fillerMask;
      this._fillerRed.visible = false;
      this._fillerRed.stop();

      this._panelParent = resourceManager.get(this._jsonPath + ':bg:panelParent');

      // Get the mask
      this._containerMask = resourceManager.get('multiplierTrailWrapper:multiplierTrailMask');
      this._containerMask.beginFill(0xffffff);
      this._containerMask.drawRect(-100, -450, 200, 772);
      this._containerMask.endFill();
      this._panelParent.mask = this._containerMask;
      this.tracerAnim = resourceManager.get(this._jsonPath + ':bg:tracerAnim');

      this.pulseTextContainer = resourceManager.get(this._jsonPath + ':bg:pulseTextContainer');

      const flashAnimContainer = resourceManager.get(this._jsonPath + ':bg:flashAnimContainer');
      this._flashAnim = particleManager.createEmitter('multiplierTrailFlash', flashAnimContainer.name, 0, 0, false);
      this._flashAnim.particleEmitter.emit = false;
      this._flashAnim.visible = false;

      for (let i = 0; i < this._segmentsCount; ++i) {
        const panel = resourceManager.get(this._jsonPath + ':bg:panelParent:panel_x' + i);
        const panelPos = resourceManager.get(this._jsonPath + ':bg:panelParent:panel_pos_' + i);
        const panelName = resourceManager.get(this._jsonPath + ':bg:panelParent:panel_x' + i).name;
        const text = resourceManager.get(panelName + ':textPanel:normal');
        text.visible = false;
        const goldText = resourceManager.get(panelName + ':textPanel:gold');
        //goldText.visible = false;
        const extraPanel = resourceManager.get(panelName + ':extraPanel');
        extraPanel.visible = false;
        const wildPanel = resourceManager.get(panelName + ':extraPanel:wildPanel');
        const wildPanelText = resourceManager.get(panelName + ':extraPanel:wildPanel:wildText');
        wildPanel.visible = false;
        const superwildPanel = resourceManager.get(panelName + ':extraPanel:superwildPanel');
        const superwildPanelText = resourceManager.get(panelName + ':extraPanel:superwildPanel:superwildText');
        superwildPanel.visible = false;
        const boostPanel = resourceManager.get(panelName + ':extraPanel:boostPanel');
        const boostPanelText = resourceManager.get(panelName + ':extraPanel:boostPanel:boostText');
        boostPanel.visible = false;
        const megawildPanel = resourceManager.get(panelName + ':extraPanel:megawildPanel');
        const megawildPanelText = resourceManager.get(panelName + ':extraPanel:megawildPanel:megawildText');
        megawildPanel.visible = false;

        let panelSlideInAnim = undefined;

        this._panels.push({
          panel,
          panelPos,
          text,
          goldText,
          extraPanel,
          wildPanel,
          superwildPanel,
          boostPanel,
          megawildPanel,
          wildPanelText,
          superwildPanelText,
          boostPanelText,
          megawildPanelText,
          panelSlideInAnim,
        });
      }

      this._gameConfigSet = true;
    }

    onLayoutChange() {
      for (let i = 0; i < this._panels.length; i++) {
        if (this._panels[i].panelSlideInAnim) {
          this._panels[i].panelSlideInAnim.kill();
          this._panels[i].panelSlideInAnim = undefined;
        }
      }

      if (systemData.isLandscape) {
        this._textPulseShift = {
          x: 0,
          y: 0,
        };
      } else {
        this._textPulseShift = {
          x: 94,
          y: 0,
        };
      }

      if (!this._gameConfigSet) {
        return;
      }

      if (this._containerMask) {
        this._containerMask.clear();
        this._containerMask.beginFill(0xffffff);

        if (systemData.isLandscape) {
          // Landscape: mask clips at bottom of trail frame
          this._containerMask.drawRect(-100, -450, 200, 772);
        } else {
          // Portrait: adjust mask for portrait positioning
          this._containerMask.drawRect(-100, -445, 200, 769);
        }

        this._containerMask.endFill();
      }

      const panelRotation = systemData.isLandscape ? 0 : -1.57;
      for (let i = 0; i < this._segmentsCount; ++i) {
        const panelPos = resourceManager.get(this._jsonPath + ':bg:panelParent:panel_pos_' + i);
        this._panels[i].panelPos = panelPos;
        this._panels[i].panel.rotation = panelRotation;
      }

      if (this.shiftPanelTween && this.shiftPanelTween.isActive()) {
        this.shiftPanelTween.progress(1);
      }

      // Reapply panel values
      if (this._trail) {
        this.setTrailPanels();
      }
    }

    onShuffleIntroEvent(task) {
      this._trail = task.data.trail;

      // Initialize current level from startingXs (X symbols collected before shuffle)
      const startingXs = task.data.startingXs || 0;
      this._currentLevel = 1;
      this._currentHeightShift = startingXs;

      this.setLevel(this._currentLevel);
    }

    onShuffleEndEvent(task) {
      if (task !== undefined) {
        this.shuffleEndTask = task;
        this.shuffleEndTask.join();

        this.fadePanelsOut();

        const self = this;
        timerManager.addTimeout(1000, function () {
          self.reset();
          self.shuffleEndTask.leave();
          self.shuffleEndTask = undefined;
        });
      }
    }

    onXtraPowerTriggerEvent(task) {
      this.onXtraPowerRedBackground({ enabled: true });
    }

    onXtraPowerRedBackground(data) {
      if (data.enabled) {
        this._fillerRed.visible = true;
        this._fillerRed.alpha = 0;
        this._fillerRed.play();
        const tween = gsap.to(this._fillerRed, {
          pixi: { alpha: 1 },
          ease: 'linear',
          duration: 0.5,
          onComplete: () => {
            this._fillerBlue.visible = false;
            this._fillerBlue.stop();
          },
        });
        if (!data.time) {
          tween.progress(1);
        }
      } else {
        this._fillerBlue.visible = true;
        this._fillerBlue.play();
        const tween = gsap.to(this._fillerRed, {
          pixi: { alpha: 0 },
          ease: 'linear',
          duration: 0.5,
          onComplete: () => {
            this._fillerRed.visible = false;
            this._fillerRed.alpha = 1;
            this._fillerRed.stop();
          },
        });
        if (!data.time) {
          tween.progress(1);
        }
      }
    }

    resetDefaultTrailData() {
      const stakeController = resourceManager.getController('stakeController');
      const data = persistence.getData(stakeController.CurrentStake);
      this._defaultTrailData = {
        trail: data.t.m,
        start: data.t.x,
      };
    }

    setDefaultTrail() {
      this._trail = [];
      this._defaultTrailData;
      for (let i = 0; i < this._defaultTrailData.trail.length; i++) {
        let trailPanel = {
          multiplier: this._defaultTrailData.trail[i],
          wildKind: 'None',
        };
        this._trail.push(trailPanel);
      }
    }

    setTrailPanels(showPanels = true, instant = true, pulseText = false) {
      let panelDelayOffset = 0;
      let activePanelText = undefined;
      let textPulsePos = Math.max(0, this._currentFillerLevel - 1);

      for (let i = 0; i < this._panels.length; i++) {
        let trailIndex = i + this._currentHeightShift;
        if (trailIndex < this._trail.length) {
          let multi = this._trail[trailIndex].multiplier;
          let panelType = this._trail[trailIndex].wildKind;
          // Panel should be gold if it's below the current filler level
          const panelIsFilled = i < this._currentFillerLevel;
          const wasGold = this._previouslyGoldPanels[i] || false;

          if (panelIsFilled) {
            this._panels[i].goldText.setText('x' + multi);
            this._panels[i].goldText.visible = true;
            this._panels[i].text.visible = false;

            // Pop animation for newly-gold panels
            if (!wasGold) {
              gsap.fromTo(
                this._panels[i].goldText.scale,
                { x: 1, y: 1 },
                {
                  x: 1.3,
                  y: 1.3,
                  duration: 0.15,
                  yoyo: true,
                  repeat: 1,
                  ease: 'power2.out',
                }
              );

              this._currentGoldText = this._panels[i].goldText;
            }
          } else {
            this._panels[i].text.setText('x' + multi);
            this._panels[i].goldText.visible = false;
            this._panels[i].text.visible = true;
          }

          // Track gold state for this panel
          this._previouslyGoldPanels[i] = panelIsFilled;

          this._panels[i].wildPanel.visible = false;
          this._panels[i].superwildPanel.visible = false;
          this._panels[i].boostPanel.visible = false;
          this._panels[i].megawildPanel.visible = false;

          const pos = {
            x: this._panels[i].panelPos.x,
            y: this._panels[i].panelPos.y,
          };
          this._panels[i].panel.position.set(pos.x, pos.y);

          // Reset extraPanel position and rotation before slide animations (fixes positioning on subsequent spins)
          this._panels[i].extraPanel.position.set(0, 0);
          this._panels[i].extraPanel.rotation = 0;
          if (showPanels) {
            if (panelType !== 'None') {
              if (panelType === 'Wild') {
                this.showPanel(this._panels[i].wildPanel, instant, panelDelayOffset, i);
                panelDelayOffset += 0.25;
                if (i === textPulsePos) {
                  activePanelText = 'Wild';
                }
              } else if (panelType === 'SuperWild') {
                this.showPanel(this._panels[i].superwildPanel, instant, panelDelayOffset, i);
                panelDelayOffset += 0.25;
                if (i === textPulsePos) {
                  activePanelText = 'SuperWild';
                }
              } else if (panelType === 'Boost') {
                this.showPanel(this._panels[i].boostPanel, instant, panelDelayOffset, i);
                panelDelayOffset += 0.25;
                if (i === textPulsePos) {
                  activePanelText = 'Boost';
                }
              } else if (panelType === 'MegaWild_X2' || panelType === 'MegaWild_X3' || panelType === 'MegaWild_X5') {
                this.showPanel(this._panels[i].megawildPanel, instant, panelDelayOffset, i);
                panelDelayOffset += 0.25;
                if (i === textPulsePos) {
                  activePanelText = 'MegaWild';
                }
              }
            }
            this._panels[i].extraPanel.visible = true;
          }
        }
      }

      if (pulseText && textPulsePos && activePanelText) {
        let textPanel;
        if (activePanelText === 'Wild') {
          textPanel = this._panels[textPulsePos].wildPanelText;
        } else if (activePanelText === 'SuperWild') {
          textPanel = this._panels[textPulsePos].superwildPanelText;
        } else if (activePanelText === 'Boost') {
          textPanel = this._panels[textPulsePos].boostPanelText;
        } else {
          textPanel = this._panels[textPulsePos].megawildPanelText;
        }

        const originalParent = textPanel.parent;
        const panelPos = this._panels[textPulsePos].panel.position;
        const labelPos = originalParent.position;
        const newPos = {
          x: panelPos.x + labelPos.x + this._textPulseShift.x,
          y: panelPos.y + labelPos.y + this._textPulseShift.y,
        };
        this.pulseTextContainer.position.set(newPos.x, newPos.y);
        this.pulseTextContainer.addChild(textPanel);

        gsap.to(textPanel.scale, {
          x: 1.5,
          y: 1.5,
          duration: 0.2,
          yoyo: true,
          repeat: 5,
          ease: 'linear',
          onComplete: () => {
            originalParent.addChild(textPanel);
            this.pulseTextContainer.position.set(0, 0);
          },
        });
      }
    }

    showPanel(panel, instant, panelDelay = 0, index) {
      panel.visible = true;
      panel.alpha = 1;
      if (!instant) {
        if (layoutController.getCurrentLayout() !== 'portrait_default') {
          this._panels[index].panelSlideInAnim = gsap.fromTo(
            panel,
            {
              y: -1000,
            },
            {
              delay: panelDelay,
              y: 0,
              duration: 1,
              onStart: () => {
                musicManager.playBonusSlideOntoTrail();
              },
              onComplete: () => {
                this._panels[index].panelSlideInAnim = undefined;
                musicManager.playBonusLandOnTrail();
              },
            }
          );
        } else {
          const panelPos = panel.position.x;
          this._panels[index].panelSlideInAnim = gsap.fromTo(
            panel,
            {
              x: 1000,
            },
            {
              delay: panelDelay,
              x: panelPos,
              duration: 1,
              onStart: () => {
                musicManager.playBonusSlideOntoTrail();
              },
              onComplete: () => {
                this._panels[index].panelSlideInAnim = undefined;
                musicManager.playBonusLandOnTrail();
              },
            }
          );
        }
      }
    }

    incrementLevel(callback) {
      if (this._currentLevel < this._maxLevel) {
        this._currentLevel++;
        this.animateFillerLevel(callback);
      } else {
        this.shiftPanelsDown(false, 1, callback);
      }
    }

    setLevel(newLevel) {
      if (newLevel < this._minLevel) {
        this._currentLevel = this._minLevel;
        this.animateFillerLevel();
      } else if (newLevel > this._maxLevel) {
        this._currentLevel = this._maxLevel;
        this.shiftPanelsDown();
      } else {
        this._currentLevel = newLevel;
        this.animateFillerLevel();
      }
    }

    async playTracerAnim() {
      for (let i = 0; i < 3; i++) {
        await Utils.playMovieAsync(this.tracerAnim);
      }
    }

    animateFillerLevel(callback) {
      if (this._currentLevel !== this._currentFillerLevel) {
        let startHeight = this._currentFillerLevel * this._segmentSize;
        let endHeight = this._currentLevel * this._segmentSize;
        let obj = { value: startHeight };
        let levelBoost = false;

        if (startHeight < endHeight) {
          this.playTracerAnim();
        }

        gsap.to(obj, {
          value: endHeight,
          duration: 1,
          ease: 'power2.inOut',
          onUpdate: () => {
            this._fillerMask.height = obj.value;
          },
          onStart: () => {
            if (this._currentLevel > this._currentFillerLevel) {
              soundManager.play('trailLevelMove');
              levelBoost = true;
            } else if (this._currentLevel < this._currentFillerLevel) {
              soundManager.play('trailLevelReset');
            }
          },
          onComplete: () => {
            this._currentFillerLevel = this._currentLevel;
            this._fillerMask.height = endHeight;
            this.setTrailPanels(true, true, levelBoost);

            if (callback) {
              callback();
            }
          },
        });
      } else {
        // No animation needed, call callback immediately
        if (callback) {
          callback();
        }
      }
    }

    shiftPanelsDown(fromOrbs = false, amount = 1, callback) {
      this._currentHeightShift += amount;

      this.shiftPanelTween = gsap.to(this._panelParent, {
        y: this._segmentSize * amount,
        duration: 1,
        ease: 'power2.inOut',
        onComplete: () => {
          this._panelParent.y = 0;
          this._previouslyGoldPanels = [];
          this.setTrailPanels(!fromOrbs);
          this.stopFlashAnim();

          if (callback) {
            callback();
          }
        },
      });
    }

    moveUpTrail(callback) {
      const backgroundDisplay = resourceManager.get(
        'slotContainer:backgroundLightningDisplay:backgroundLightningDisplay'
      );
      backgroundDisplay.incrementLevel();
      this.incrementLevel(callback);
    }

    /**
     * Move the trail to a specific level based on the server's multiplier value.
     * This handles cases where the trail may skip levels (e.g., 1 → 3 → 4 → 5).
     * @param {number} targetMultiplier - The target level to move to
     * @param {function} callback - Called when animation completes
     */
    moveToLevel(targetMultiplier, callback) {
      const backgroundDisplay = resourceManager.get(
        'slotContainer:backgroundLightningDisplay:backgroundLightningDisplay'
      );

      const targetLevel = this.getTrailIndexForMultiplier(targetMultiplier) + 1;

      // Calculate how many levels we're advancing
      const currentEffectiveLevel = this._currentLevel + this._currentHeightShift;
      const levelsToAdvance = targetLevel - currentEffectiveLevel;

      // Update background display for each level advanced
      // for (let i = 0; i < levelsToAdvance; i++) {
      if (levelsToAdvance > 0) {
        backgroundDisplay.incrementLevel();
        this._currentLevel++;
      }

      // Calculate the display level and any needed shift
      const displayLevel = Math.min(this._currentLevel, this._maxLevel);
      const shiftNeeded = Math.max(0, this._currentLevel - this._maxLevel);

      if (shiftNeeded > 0) {
        // Need to shift panels down
        this._currentLevel = 1;
        this.animateFillerLevel(() => {
          this.shiftPanelsDown(false, this._maxLevel, callback);
        });
      } else {
        // Just animate the filler to the new level
        this._currentLevel = displayLevel;
        this.animateFillerLevel(callback);
      }
    }

    readyFlashAnim() {
      this._flashAnim.visible = true;
    }

    playFlashAnim() {
      this._flashAnim.particleEmitter.emit = true;
    }

    stopFlashAnim() {
      this._flashAnim.particleEmitter.emit = false;
    }

    resetFlashAnim() {
      this._flashAnim.visible = false;
      this._flashAnim.particleEmitter.emit = false;
    }

    reset() {
      this._currentLevel = this._defaultTrailData.start;
      this.setLevel(1);
      this._currentHeightShift = this._defaultTrailData.start;
      this._previouslyGoldPanels = [];

      for (let i = 0; i < this._panels.length; i++) {
        this._panels[i].wildPanel.visible = false;
        this._panels[i].superwildPanel.visible = false;
        this._panels[i].boostPanel.visible = false;
        this._panels[i].megawildPanel.visible = false;
        this._panels[i].extraPanel.position.set(0, 0);
        this._panels[i].extraPanel.rotation = 0;
        this._panels[i].extraPanel.alpha = 1;
      }
      this.setDefaultTrail();
      this.setTrailPanels();
    }

    /**
     * Find the trail index for a given multiplier value.
     * The trail array has non-sequential multipliers (1,2,3,4,5,6,8,10,12,15,...).
     * @param {number} multiplierValue - The multiplier value to find (e.g., 8)
     * @returns {number} The index in the trail array
     */
    getTrailIndexForMultiplier(multiplierValue) {
      for (let i = 0; i < this._trail.length; i++) {
        if (this._trail[i].multiplier === multiplierValue) {
          return i;
        }
      }
    }

    getCurrentTrailScreenPosition(panelIndex) {
      const wrapper = resourceManager.get('multiplierTrailWrapper');
      const wrapperPos = wrapper.position;
      const wrapperRotation = wrapper.rotation;
      if (panelIndex === undefined) {
        panelIndex = this._currentLevel - 1;
      }
      panelIndex = Math.min(panelIndex, this._panels.length - 1);
      const panelPos = this._panels[panelIndex].panel.position;

      // 2D rotation transformation to deal with horizontal vs vertical trail
      const localX = panelPos.x;
      const localY = panelPos.y + this.position.y;
      const cos = Math.cos(wrapperRotation);
      const sin = Math.sin(wrapperRotation);
      const pos = {
        x: wrapperPos.x + localX * cos - localY * sin,
        y: wrapperPos.y + localX * sin + localY * cos,
      };
      return pos;
    }

    getCurrentTotalLevel() {
      return this._currentLevel + this._currentHeightShift;
    }

    onPersistenceStakeChanged(data) {
      const differences = persistence.getDifferencesBetween2Objects(this._defaultTrailData, {
        trail: data.data.t.m,
        start: data.data.t.x,
      });

      if (differences) {
        this._defaultTrailData = {
          trail: data.data.t.m,
          start: data.data.t.x,
        };
        this.reset();
      }
    }

    scaleGoldText() {
      const tl = gsap.timeline();
      const duration = 0.3;

      for (let i = 0; i < 2; i++) {
        tl.to(this._currentGoldText.scale, {
          x: 1.4,
          y: 1.4,
          duration: duration,
          ease: 'power2.out',
        }).to(this._currentGoldText.scale, {
          x: 1,
          y: 1,
          duration: duration,
          ease: 'power2.in',
        });
      }
    }

    fadePanelsOut() {
      for (let i = 0; i < this._panels.length; i++) {
        const extraPanel = this._panels[i].extraPanel;

        gsap.to(extraPanel, {
          alpha: 0,
          duration: 1,
          ease: 'linear',
        });
      }
    }
  }

  let creator = function (json) {
    return new MultiplierTrail(json.reel);
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('multiplierTrail', creator, initialise, filesRequired);
})();
